<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-20 13:57:15
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-14 16:04:33
 * @FilePath: /chaoyongtuan/src/modules/async/goods/synchronizationList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="synchronization-list">
		<div class="synchronization-head">
			<div class="commander-info font-h4-medium">团长信息</div>
			<div class="commander-ID font-h4-medium">团长ID</div>
			<div class="snchronous-not font-h4-medium">是否可同步</div>
		</div>
		<div class="commander-content" v-loading="loading" v-if="list.length">
			<div class="commander-list" v-for="item in list" :key="item.tripartiteInstId" @click="selectClick(item)">
				<div class="commander-name">
					<el-radio :value="+authorityId" :label="+item.tripartiteInstId" :disabled="!item.synced"></el-radio>
					<div class="institution_name">{{ item.instName }}</div>
				</div>
				<el-tooltip placement="top" :open-delay="300">
					<div slot="content">
						<span>团长ID</span>
						<span class="ml-4">{{ item.tripartiteInstId || '-' }}</span>
						<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(item.tripartiteInstId)"></i>
					</div>
					<div class="commander-only">{{ (item.tripartiteInstId + '') | textFormat(17) }}</div>
				</el-tooltip>
				<div class="commander-snchronous">
					<div class="font-h6-regular" v-if="item.synced">可同步</div>
					<div v-else>不可同步（正在进行中）</div>
				</div>
			</div>
		</div>
		<empty v-else ref="empty" slot="empty"></empty>
	</div>
</template>
<script>
import empty from '@/views/common/empty/index.vue';
import { copy } from '@/utils/common';
import { institutionListJava } from '@/api/teamManage';
export default {
	data() {
		return {
			list: [],
			authorityId: -1,
			loading: false,
		};
	},
	props: {
		platformId: {
			type: [Number, String],
			default: 1,
		},
	},
	components: {
		empty,
	},
	methods: {
		async getList() {
			try {
				this.loading = true;
				const { platformId } = this;
				const temPF = {
					[dataMap.PLATFORM_DY.value]: '12',
					[dataMap.PLATFORM_SP.value]: '31',
				};
				let params = {
					tripartiteType: temPF[platformId], //业务类型
					platformId,
				};
				this.list = await institutionListJava(params);
			} finally {
				this.loading = false;
			}
		},
		selectClick(item) {
			if (!item.synced) {
				return;
			}
			this.authorityId = item.tripartiteInstId;
			this.$emit('change', item);
		},
		timeEnd() {
			this.getList();
		},
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
	created() {
		this.getList();
	},
};
</script>
<style lang="less" scoped>
.synchronization-list {
	padding-top: 24px;
	.synchronization-head {
		display: flex;
		align-items: center;
		padding: 16px;
		border-bottom: 1px solid @border-color-base;
		.commander-info {
			width: 206px;
			color: @color-text-regular;
		}
		.commander-ID {
			width: 206px;
			color: @color-text-regular;
		}
		.snchronous-not {
			width: 140px;
			color: @color-text-regular;
		}
	}
	.commander-content {
		max-height: 280px;
		overflow: auto;
		/deep/ .el-radio__label {
			padding-left: 0px;
			display: none;
		}
	}
	.commander-list {
		cursor: pointer;
		display: flex;
		align-items: center;
		padding: 16px;
		border-bottom: 1px solid @border-color-base;
		/deep/ .el-radio {
			position: relative;
			top: 3px;
			margin-right: 12px;
		}
		.commander-name {
			display: flex;
			width: 206px;
			color: @color-text-regular;
			.institution_name {
				width: 160px;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
			}
		}
		.commander-only {
			width: 206px;
			color: @color-text-regular;
		}
		.commander-snchronous {
			width: 140px;
			color: @color-text-regular;
		}
	}
	.down-time {
		display: inline-block;
		min-width: 60px;
		color: @color-o;
		font-size: 12px;
		font-family: 'PingFangSC-Regular';
	}
	.down-text {
		color: @color-o;
		font-family: 'PingFangSC-Regular';
	}
}
</style>
